import { useEffect, useState, useRef } from "react";
import { getMercadoPago, sendPayu } from "../services/paymentService";
import { PAYMENT_CONFIG } from "../../../constants/payments";
import { useMercadopago } from "react-sdk-mercadopago";

const usePayment = (form_pay, setLoading) => {
  const [urlPayu, setUrlPayu] = useState(null);
  const [idMercado, setIdMercado] = useState(null);
  const hasProcessed = useRef(false);

  // Inicialización del SDK de MercadoPago
  const mercadopago = useMercadopago.v2(
    PAYMENT_CONFIG.MERCADO_PAGO.PUBLIC_KEY,
    {
      locale: PAYMENT_CONFIG.MERCADO_PAGO.LOCALE,
    }
  );

  const processPayment = async () => {
    try {
      setLoading(true);
      if (form_pay.pasarela === "pay_u") {
        const payuData = await sendPayu(form_pay);
        setUrlPayu(payuData);
      } else {
        const mercadoData = await getMercadoPago({
          contrato: form_pay.contrato,
          valor: parseInt(form_pay.valor),
          codigo: form_pay.codigo,
        });
        setIdMercado(mercadoData);
      }
    } catch (error) {
      console.error("Error procesando el pago:", error);
      alert("Hubo un error al procesar el pago. Por favor intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  const renderMercadoPagoButton = (preferenceId) => {
    try {
      if (!mercadopago) {
        console.error("MercadoPago SDK no está disponible aún");
        return;
      }
      if (!preferenceId) {
        console.error("No se recibió una preferencia de pago válida");
        return;
      }

      mercadopago.checkout({
        preference: {
          id: preferenceId,
        },
        render: {
          container: `.${PAYMENT_CONFIG.MERCADO_PAGO.CONTAINER_CLASS}`,
          label: "Pagar con Mercado Pago",
        },
      });
    } catch (error) {
      console.error("Error renderizando botón de Mercado Pago:", error);
      alert("Error al cargar la pasarela de pago. Por favor recarga la página.");
    }
  };

  useEffect(() => {
    // Evitar llamadas duplicadas
    if (!hasProcessed.current && form_pay.pasarela) {
      hasProcessed.current = true;
      processPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idMercado && mercadopago) {
      renderMercadoPagoButton(idMercado);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idMercado, mercadopago]);

  // useTimeOut(() => renderMercadoPagoButton(idMercado), 2000);
  return { urlPayu, idMercado };
};

export default usePayment;
